import { browser } from '$app/environment';
import { RECURLY_KEY } from '$lib/constants';
import type { Api_Order } from '$lib/types/api/graphql';
import { delay } from '$lib/utils';

const MAX_RETRIES = 15;

export async function applyTax(result: Api_Order, country: string, postalCode: string, retryCount = 0) {
  if (!browser) {
    return;
  }

  if (!window.recurly) {
    if (retryCount >= MAX_RETRIES) {
      return;
    }

    await delay(100);
    return applyTax(result, country, postalCode, retryCount + 1);
  }

  if (!country || result.totalDue === 0) return;

  return new Promise<{ taxes: string; total: string }>(resolve => {
    if (!window.recurly.configured) {
      window.recurly.configure(RECURLY_KEY);
    }
    const checkoutPrice = window.recurly.Pricing.Checkout();
    checkoutPrice
      .currency('USD')
      .address({ country, postal_code: postalCode })
      .adjustment({
        id: 0,
        amount: result.totalDue,
        quantity: 1
      })
      .done(({ now }: { now: { taxes: string; total: string } }) => {
        resolve(now);
      });
  });
}
